import { Typography, Box, styled, classes } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';

const StyledBox = styled(Box)(({ theme }) => ({
  borderRadius: '3px',
  margin: '10px 0',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  border: `2px solid ${theme.palette.purple.main}`,
  color: theme.palette.purple.main,
  backgroundColor: '#FFFFFF',
  maxWidth: '100%',
  [`& .${classes.components.MuiTypography.root}`]: {
    color: theme.palette.purple.main,
  },
}));

const WelcomeBanner = props => {
  const { t } = useTranslation();

  return (
    <StyledBox>
      <Typography
        variant="h2"
        sx={{
          fontSize: '0.95rem',
          fontWeight: 600,
          paddingBottom: '10px',
        }}
      >
        {t('settings.add_instructions')}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          fontSize: '0.85rem',
          fontWeight: 400,
          lineHeight: '20px',
        }}
      >
        {props.bannerBody}
      </Typography>
    </StyledBox>
  );
};

export default WelcomeBanner;
